<div class="reward-overview-form-root">
  <div class="reward-overview-card-info">
    <app-reward-card
      [reward]="reward"
      [showDefaultImage]="!!!reward.imgSource"
      [showActions]="false"
    ></app-reward-card>
    <app-reward-info [availableFamilies]="availableFamilies"
                     [availableBusinessLevels]="availableBusinessLevels"
                     [data]="rewardInfoData"></app-reward-info>
  </div>

  <h3>{{ labels.setRewardPeriod }}</h3>

  <div class="reward-period">
    <div class="start-date">
      <p>{{ labels.startDate }}: <span class="required"> *</span></p>
      <app-input
        [control]="startDateControl"
        [datepicker]="startDate"
        [minDate]="minDate"
        [placeholder]="DATE_PLACEHOLDER"
        readonly
      ></app-input>

      <mat-datepicker-toggle
        matIconSuffix
        [for]="startDate"
      ></mat-datepicker-toggle>

      <mat-datepicker #startDate></mat-datepicker>
    </div>

    <div class="end-date">
      <p>{{ labels.endDate }}: <span class="required"> *</span></p>
      <app-input
        [control]="endDateControl"
        [datepicker]="endDate"
        [disabled]="isEndDateDisabled"
        [minDate]="startDateControl.value!"
        [placeholder]="DATE_PLACEHOLDER"
        readonly
      ></app-input>

      <mat-datepicker-toggle
        [disabled]="isEndDateDisabled"
        [for]="endDate"
        matIconSuffix
      ></mat-datepicker-toggle>

      <mat-datepicker #endDate [disabled]="isEndDateDisabled"></mat-datepicker>

      <mat-checkbox
        color="primary"
        [(ngModel)]="isEndDateDisabled"
        (change)="onEndDateDisableChange($event)"
      >
        {{ labels.undeterminedEndDate }}
      </mat-checkbox>
    </div>
  </div>
</div>
